/**
 * @generated SignedSource<<d1a45550a7501566675341f44d0996de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PerpsPoolBalanceWithdrawFragment$data = {
  readonly id: string;
  readonly liquidityCooldown: {
    readonly endAt: any;
    readonly startAt: any;
  } | null | undefined;
  readonly lpSize: {
    readonly amount: bigint;
  };
  readonly " $fragmentType": "PerpsPoolBalanceWithdrawFragment";
};
export type PerpsPoolBalanceWithdrawFragment$key = {
  readonly " $data"?: PerpsPoolBalanceWithdrawFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PerpsPoolBalanceWithdrawFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PerpsPoolBalanceWithdrawFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Balance",
      "kind": "LinkedField",
      "name": "lpSize",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PerpsLiquidityCooldown",
      "kind": "LinkedField",
      "name": "liquidityCooldown",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PerpsAccount",
  "abstractKey": null
};

(node as any).hash = "223e04260078d646d6c3963f1ae41d2a";

export default node;
